<template>
  <div id="news">
    <v-card color="#92D050">
      <v-card-title>Aktuelle Urteile</v-card-title>
      <v-card-text>
        <v-sheet color="#92D050" >
          <iframe ref="mio" id="mio" src="https://www.deubner-online.de/einbau/mio/bin/iframe_inhalt.php?ota=OTA-2022149094&variante=tagesaktuell" width="100%" height="600px" leftmargin="0" align="center" frameborder="0" allowtransparency="true" style="padding:0px"></iframe>
        </v-sheet>
         </v-card-text>
    </v-card>
   </div>
 </template>

<script>
export default {
  name: "News",
  data: () => ({
  }),
}
</script>

<style scoped>
  #news {
    color: white !important;
  }
  #mio {
    background-color: #92D050 !important;
  }
  #mio #auswahlStandard {
    background-color: #92D050 !important;
    border: 0
  }
</style>
